import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './redux/registrationPopupActions';
import {openSignInPopup} from '../SignInPopup/redux/signInPopupActions';
import styles from '../../styles/AuthPopup.scss';
import RegistrationPopupSocBtns from './elements/RegistrationPopupSocBtns';
import RegistrationPopupInput from './elements/RegistrationPopupInput';

export class RegistrationPopup extends Component {
  switchToLogIn = () => {
    this.props.actions.closeRegistrationPopup();
    this.props.actions.openSignInPopup();
  };

  render() {
    const {actions, isOpen} = this.props;
    if (!isOpen) {
      return null;
    }
    return (
      <div>
        <div
        onClick={actions.closeRegistrationPopup}
        className={styles.backDrop} />

        <div className={styles.popupWindow}>
          <div
            onClick={actions.closeRegistrationPopup}
            className={styles.closeBtn} />
          <div className={styles.header}>
            Регистрация
          </div>
          <RegistrationPopupInput popoverOnTop />
          {/* <div className={styles.divider} />
          <p
          className={styles.socRegistrationPrompt}>
            Регистрация через соц. сеть
          </p>
          <RegistrationPopupSocBtns {...actions} /> */}
          <div className={styles.divider} />
          <button
            onClick={this.switchToLogIn}
            className="link">Войти</button>
        </div>
      </div>
    );
  }
}



RegistrationPopup.propTypes = {
  actions: PropTypes.object.isRequired,
  isOpen: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    ...state.registrationPopupReducer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...actions, openSignInPopup}, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationPopup);



/** WEBPACK FOOTER **
 ** ./src/components/RegistrationPopup/RegistrationPopup.jsx
 **/